import moment from 'moment-timezone';
import api from './api';

export default {
  get(date) {
    const path = '/api/v1/holidays';

    return api({
      method: 'get',
      url: path,
      params: { date: moment(date).format('YYYY-MM-DD') },
    });
  },
};
